/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanyIdentityResource } from './';
import {
    CompanyIdentityResourceFromJSON,
    CompanyIdentityResourceFromJSONTyped,
    CompanyIdentityResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyIdentitySearchResultResource
 */
export interface CompanyIdentitySearchResultResource {
    /**
     * 
     * @type {Array<CompanyIdentityResource>}
     * @memberof CompanyIdentitySearchResultResource
     */
    items: Array<CompanyIdentityResource>;
    /**
     * 
     * @type {number}
     * @memberof CompanyIdentitySearchResultResource
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyIdentitySearchResultResource
     */
    totalPages: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyIdentitySearchResultResource
     */
    hasNext: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyIdentitySearchResultResource
     */
    hasPrevious: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanyIdentitySearchResultResource
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyIdentitySearchResultResource
     */
    pageSize: number;
}

/**
 * Check if a given object implements the CompanyIdentitySearchResultResource interface.
 */
export function instanceOfCompanyIdentitySearchResultResource(value: object): value is CompanyIdentitySearchResultResource {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    if (!('hasNext' in value) || value['hasNext'] === undefined) return false;
    if (!('hasPrevious' in value) || value['hasPrevious'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    return true;
}

export function CompanyIdentitySearchResultResourceFromJSON(json: any): CompanyIdentitySearchResultResource {
    return CompanyIdentitySearchResultResourceFromJSONTyped(json, false);
}

export function CompanyIdentitySearchResultResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyIdentitySearchResultResource {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(CompanyIdentityResourceFromJSON)),
        'totalCount': json['totalCount'],
        'totalPages': json['totalPages'],
        'hasNext': json['hasNext'],
        'hasPrevious': json['hasPrevious'],
        'page': json['page'],
        'pageSize': json['pageSize'],
    };
}

export function CompanyIdentitySearchResultResourceToJSON(value?: CompanyIdentitySearchResultResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'items': ((value['items'] as Array<any>).map((v) => CompanyIdentityResourceToJSON(v))),
        'totalCount': value['totalCount'],
        'totalPages': value['totalPages'],
        'hasNext': value['hasNext'],
        'hasPrevious': value['hasPrevious'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

